import { render, staticRenderFns } from "./ModalModulos.vue?vue&type=template&id=7ae8b52d"
import script from "./ModalModulos.vue?vue&type=script&lang=js"
export * from "./ModalModulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports